module.exports = __webpack_public_path__ + "static/media/google-plus.9c10b190.svg";